import { Link } from 'shared/types';

export const isGeoEventLinkValid = (link: Link): boolean => {
  return Object.values(link).every((value) => value && value.trim() !== '');
};
